import React from "react";
import Banner from "../../../components/Bannersection/banner";
import { Helmet } from "react-helmet";
import {
  BsShieldCheck,
  BsGraphUp,
  BsReceipt,
  BsCalculator,
  BsSearch,
  BsGrid1X2Fill,
} from "react-icons/bs";
import { FiActivity } from "react-icons/fi";
import { FaTruck } from "react-icons/fa";
import Faq from "../../../components/Faq/faq";
import Boxcard from "../../../components/Cardesection/boxcard";
import PricingSection from "../../../components/PricingSection/PricingSection";

const pagename = [
  {
    pagetitle: "Boox365 Accounting",
    subtitle: "Modern Accounting Made Effortless",
  },
];

const faqitem = [
  {
    Faq_id: "collapseone",
    data_bs_target: "#collapseone",
    question: "Is my financial data secure with Boox365?",
    answer:
      "Yes, we use enterprise-grade SSL encryption and multi-layered security protocols to ensure your data is safe and accessible only to authorised users.",
  },
  {
    Faq_id: "collapsetwo",
    data_bs_target: "#collapsetwo",
    question: "Does it support GST filing and compliance?",
    answer:
      "Absolutely. Boox365 is fully GST-ready for Australian businesses, allowing you to generate BAS lodgements, GST returns, and tax invoices with ease.",
  },
  {
    Faq_id: "collapseThree",
    data_bs_target: "#collapseThree",
    question: "Can I manage multiple businesses under one account?",
    answer:
      "Yes, our enterprise plans support multi-company management, allowing you to switch between different business entities seamlessly.",
  },
  {
    Faq_id: "collapsefour",
    data_bs_target: "#collapsefour",
    question: "Can I migrate my data from MYOB or Excel?",
    answer:
      "Yes, we provide easy-to-use import tools and templates to migrate your masters and opening balances from MYOB, Xero, Excel, or other software.",
  },
];

function Boox365Accounting() {
  const accountingService = [
    {
      icons: BsReceipt,
      title: "E-Invoicing",
      description:
        "Create professional tax invoices and get paid faster with Boox365. Our platform ensures your invoices are GST-compliant, branded, and instantly shareable with clients.",
    },
    {
      icons: BsGraphUp,
      title: "Real-Time Reports",
      description:
        "Get instant insights into your cash flow, profit margins, and overall business health. Generate automated dashboards and detailed reports.",
    },
    {
      icons: FiActivity,
      title: "Expense Track",
      description:
        "Never lose track of where your money goes. Log expenses, categorise spending, and monitor budgets in real time. Gain full control of your financial activity.",
    },
    {
      icons: BsShieldCheck,
      title: "GST and BAS Ready",
      description:
        "Tax season doesn't need to be stressful. Automatically calculate GST, generate compliant BAS lodgements, and stay ATO audit-ready at all times.",
    },
    {
      icons: FaTruck,
      title: "Payment Processing",
      description:
        "Streamline payments with built-in processing tools. Accept credit cards, bank transfers, and BPAY while automatically reconciling transactions against your accounts.",
    },
    {
      icons: BsGrid1X2Fill,
      title: "Business Suite Integration",
      description:
        "Manage accounting, inventory, sales, and tax in one streamlined platform â€” no more switching apps. Complete financial management in one place.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Boox365 Accounting | Cloud Accounting for Australian Business | DGi WORX</title>
        <meta
          name="description"
          content="Revolutionise your financial management with Boox365 Accounting. An intelligent, automated cloud platform built for Australian businesses with full GST and BAS compliance."
        />
        <meta property="og:url" content="https://dgiworx.com.au/accounting-boox" />
        <link rel="canonical" href="https://dgiworx.com.au/accounting-boox" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />
      <h1 className="d-none">Boox365 Accounting - Cloud Accounting Software for Australian Businesses</h1>

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mt-10 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-about-two-thumb">
                  <div className="tp-about-circle">
                    <div className="tp-about-circle-two">
                      <img src="/assets/img/product/boox365accounting.webp" alt="Boox365 Accounting Software" loading="lazy" />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay wow"></div>
                  <img src="/assets/img/service/artificial-intelligence/ai.jpg" alt="" loading="lazy" />
                </div>
                <div className="tp-about-two-thumb-shape-two d-none d-md-block">
                  <img src="/assets/img/about/two/dote.png" alt="" loading="lazy" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-10 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">SMART FINANCIAL SUITE</span>
                  <h2 className="tp-section-title">Next-Gen Accounting.</h2>
                  <div className="tp-section-title-wrapper">
                    <p>
                      Boox365 Accounting is engineered to automate your financial workflows and give you back your time. As an intelligent, all-in-one cloud financial suite, we handle everything from complex multi-currency ledger management to smart inventory and GST compliance. Whether you're an ambitious startup or a scaling enterprise, our platform adapts dynamically, offering you real-time visibility and absolute control over your core financial metrics.
                    </p>
                  </div>
                </div>
                <div>
                  <ul className="tp-about-one-list">
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Automated Secure Invoicing</strong> â€“ Generate and dispatch GST-compliant invoices in seconds.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>Real-Time Cash Flow Analytics</strong> â€“ Monitor your business engine with live metric tracking.
                    </li>
                    <li>
                      <span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>
                      <strong>BAS & Tax Readiness</strong> â€“ Generate ATO audit-ready returns instantly.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-about-two-shape">
          <div className="tp-about-two-shape-4">
            <img src="/assets/img/about/two/about-2-shape-2.png" alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="feature-area py-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-12">
              <div className="tp-section text-center mb-100">
                <span className="tp-section-sub-title">Automated Workflows</span>
                <h2 className="tp-section-title col-lg-8 col-sm-12 text-dark mx-auto">Intelligent Financial Processing</h2>
                <h3 className="section-sub-title col-lg-10 col-sm-12 text-dark mx-auto">
                  Experience a frictionless financial cycle powered by automated data integration and real-time computation.
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            {[
              { icon: BsSearch, title: "Smart Data Integration", desc: "Connect your bank accounts and upload receipts for automatic categorisation. Streamline your financial data entry effortlessly." },
              { icon: BsCalculator, title: "Real-time Processing", desc: "Our powerful engine processes your transactions instantly, keeping your ledgers up to date and audit-ready at all times." },
              { icon: BsShieldCheck, title: "ATO-Compliant", desc: "Easily review your financial status and ensure tax compliance. Generate GST-ready BAS lodgements and reports with a single click." },
            ].map((f, i) => (
              <div key={i} className="col-lg-4 col-md-6 mb-30">
                <div className="tp-feature-4-item" style={{ height: "100%" }}>
                  <div className="tp-feature-4-thumb" data-background=""></div>
                  <div className="tp-feature-4-item-wrapper">
                    <div className="tp-feature-4-item-icon"><i><f.icon className="flaticon-solution" /></i></div>
                    <div className="tp-feature-4-item-content">
                      <h4 className="tp-feature-4-item-title">{f.title}</h4>
                      <p>{f.desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="step-area step-area-back py-50">
        <div className="container">
          <div className="tp-section text-center mt-10 mb-50">
            <span className="tp-section-sub-title">KEY BENEFITS</span>
            <h4 className="tp-section-title">Smarter Accounting. Exponential Growth.</h4>
            <p className="text-center col-lg-10 mx-auto">
              With Boox365, your financial data transforms from static records into dynamic growth catalysts. Discover unprecedented accuracy, automate tedious reconciliation, and guarantee absolute compliance without lifting a finger.
            </p>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-step-wrapper d-flex justify-content-between">
                {[
                  { num: 1, img: "why_choose-1.jpg", icon: BsGraphUp, title: "Real-Time Dashboards", sub: "Best Finance Management Software" },
                  { num: 2, img: "why_choose-2.jpg", icon: BsCalculator, title: "Bank Reconciliation", sub: "Automated Bookkeeping Software" },
                  { num: 3, img: "why_choose-3.jpg", icon: BsShieldCheck, title: "Compliant & ATO Ready", sub: "All-in-one Bookkeeping Software" },
                  { num: 4, img: "why_choose-4.jpg", icon: BsReceipt, title: "BAS Ready Outputs", sub: "Smart Tax and Billing Software" },
                ].map((step, i) => (
                  <div key={i} className={`tp-step-item ${i % 2 !== 0 ? 'tp-step-item-even' : ''} text-center mb-30 wow bounceIn`} data-wow-duration=".6s" data-wow-delay=".5s">
                    <div className="tp-step-item-count"><span>{step.num}</span></div>
                    <div className="tp-step-item-overlay p-relative mb-30">
                      <div className="tp-step-item-thumb">
                        <img src={`assets/img/artificial_intelligence/${step.img}`} alt="" loading="lazy" />
                      </div>
                      <div className="tp-step-item-thumb-icon"><i><step.icon className="flaticon-design" /></i></div>
                    </div>
                    <div className="tp-step-item-content">
                      <h4 className="tp-step-item-title">{step.title}</h4>
                      <p>{step.sub}</p>
                    </div>
                  </div>
                ))}
                <div className="tp-step-line-shape d-none d-xl-block">
                  <img src="/assets/img/thumbs/step/step-line-shape-1.svg" alt="" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-area py-50 p-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">FEATURES</span>
                <h2 className="tp-section-title">Explore Our Key Features</h2>
                <p className="col-lg-10 mx-auto">
                  Managing business finances doesn't have to be complicated. With Boox365, you get everything you need in one powerful solution â€” built for Australian businesses.
                </p>
              </div>
            </div>
          </div>
          <Boxcard item={accountingService} />
        </div>
        <div className="tp-feature-shape">
          <div className="tp-feature-shape-one w-img">
            <img src="/assets/img/feature/one/features-bg.png" alt="Elevating Possibilities" loading="lazy" />
          </div>
        </div>
      </section>

      {/* <PricingSection productKey="accounting" title="Accounting Plans & Pricing" /> */}
      <Faq items={faqitem} />
    </div>
  );
}

export default Boox365Accounting;
